import { render, staticRenderFns } from "./AllOrderList.vue?vue&type=template&id=4822ce72&scoped=true"
import script from "./AllOrderList.vue?vue&type=script&lang=js"
export * from "./AllOrderList.vue?vue&type=script&lang=js"
import style0 from "./AllOrderList.vue?vue&type=style&index=0&id=4822ce72&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4822ce72",
  null
  
)

export default component.exports